<div class="container">
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
  </div>
  
  <div class="firstContainer">
    <div class="gen">
      <div class="firstGen">{{ 'Generate App' | translate }}</div>
      <div class="secondGen">{{ 'Create your app builds for Android, iOS, and APK.' | translate }}</div>
    </div>
    <div class="tabs">
      <a routerLink="android-builder" routerLinkActive="active">{{ 'Android Builder' | translate }}</a>
      <a routerLink="android-apk" routerLinkActive="active">{{ 'Android APK' | translate }}</a>
      <a routerLink="ios-builder" routerLinkActive="active">{{ 'IOS Builder' | translate }}</a>
      <a *ngIf="loginService.getCurrentUser().admin" routerLink="auto-build" routerLinkActive="active">{{ 'Automatic Build' | translate }}</a>
    </div>
  </div>
  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
</div>